
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sdks/[slug]",
      function () {
        return require("private-next-pages/sdks/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sdks/[slug]"])
      });
    }
  